export default __webpack_public_path__ + "static/media/israellogo.a151c7f9.png";